import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQueryWithReauth } from "../authorization/authService";

export const bankApi = createApi({
  reducerPath: "bankApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Bank"], // Updated tag type to 'BankAdmin'
  endpoints: (builder) => ({
    // Whether the bank has an active Bank Administrator. Public: the registration
    // form asks it for a visitor, and the answer names nobody.
    getBankHasAdmin: builder.query({
      query: (bankId) => ({
        url: `/bank/${bankId}/has-admin`,
        method: "GET",
      }),
      providesTags: (result, error, bankId) => [{ type: "Bank", bankId }],
    }),
  }),
});

export const { useGetBankHasAdminQuery } = bankApi;
